import React from 'react'

export const Head = ({ titleSuffix }) => {
	return (
		<>
			<title>{`Whispr | ${titleSuffix || 'Get Anonymous Q&A'}`}</title>
			<meta property='og:image' content='/og_image.svg' />
			<meta
				property='og:title'
				content={`Whispr | ${titleSuffix || 'Get Anonymous Q&A'}`}
			/>
			<meta
				property='og:desciprtion'
				content='Whispr - Ask anything, get private answers. Enrich your social network with Whispr.'
			/>
			<meta
				name='desciprtion'
				content='Whispr - Ask anything, get private answers. Enrich your social network with Whispr.'
			/>
		</>
	)
}
